import { SVGProps, Ref, forwardRef } from 'react';

export const SendAndroidOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.84 6.631c.218.67.328 1.008.33 1.357V8c0 .352-.11.691-.33 1.368l-.322.995C.61 13.16.158 14.556.804 15.223s1.87.065 4.318-1.142l6.833-3.369C14.318 9.547 15.5 8.964 15.5 8s-1.182-1.547-3.545-2.712l-6.833-3.37C2.675.713 1.452.11.804.777c-.647.668-.193 2.065.714 4.86zm9.496-.088L4.503 3.175C3.278 2.57 2.49 2.186 1.93 2q.01.069.026.152c.125.67.428 1.614.895 3.053l.322.994.041.125.067.205L9.748 8 3.28 9.47l-.067.207-.04.125-.323.994c-.467 1.439-.77 2.382-.895 3.053q-.016.083-.026.152c.56-.186 1.35-.57 2.574-1.175l6.833-3.368c1.226-.605 1.994-.988 2.477-1.325q.11-.076.177-.132a3 3 0 0 0-.177-.132c-.483-.337-1.251-.72-2.477-1.325"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
SendAndroidOutlinedSize16Glyph.displayName = 'SendAndroidOutlinedSize16Glyph';
